import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';
import md5 from 'crypto-js/md5';

import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import ImageScroller from '../../components/imagescroller';
import HelpText from '../../components/gui/helpText';
import Input from '../../components/form/input';
import GuiList from '../../components/gui/list';
import UserProfileInline from '../../components/user/profileInline';
import Camera from '../../components/gui/camera';

import localUtil from '../../lib/util';
import { QRCodeSVG } from 'qrcode.react';

function conventionImg(img, props, size = '150x') {
    if (typeof img !== 'object') {
        return undefined;
    }
    const imgSrc = `${img.s3LargeLink}`;
    return imgSrc;
}

const MARKDOWN_OPTIONS = {
	pedantic: false,
	gfm: true,
	breaks: true,
	sanitize: false,
	smartLists: true,
	smartypants: true,
	xhtml: true,
    highlight: function(code, lang) {
        const hljs = require('highlight.js');
        const language = hljs.getLanguage(lang) ? lang : 'plaintext';
        return hljs.highlight(code, { language }).value;
      },
    langPrefix: 'hljs language-', // highlight.js css expects a top-level 'hljs' class.
};

class ConventionViewInfo extends Component {
  	constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { isStarted, countdown } = this.props;
        const { appState, userStore, conventionStore, conventionResultStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isCustomerAdmin, isTester, isVeterinary, language, searchUsersResult } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { convention, jwtToken, otp = '' } = conventionStore;

        return (<>

            {isStarted ? <>
            </> : <>
                <div class='d-flex'>
                    {/* {JSON.stringify(convention)} */}
                    <ImageScroller
                        images={convention.images}
                        stores={this.props.stores}
                        showImg={img => conventionImg(img, this.props, '1920x')}
                        showImageInfo={false}
                    />
                </div>
            </>}

            <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3 mt-1`}>
                {isStarted ? <>
                    {[
                        'startDate',
                        'endDate',
                    ].map(key => {
                        if (util.isUndefined(convention[key])) {
                            return '';
                        }
                        const field = fields.getField('convention', key);
                        if (!field) {
                            console.log('Missing field:', key);
                        }
                        const displayValue = field?.displayValue || (value => value);
                        return (<>
                            {(convention[key] || convention[key] === false) && <div class='d-flex flex-row'>
                                {!['ingress', 'body'].includes(key) && <span class='text-muted font-weight-light'>
                                    {field.title}
                                </span>}
                                {['textarea', 'textareaEditor'].includes(field.type) ? <>
                                    <div class='ml-0  mb-4 text-wrap' style='max-height: 60vh; overflow: auto;'>
                                        <Markdown markdown={displayValue(convention[key])} markedOpts={MARKDOWN_OPTIONS} />
                                    </div>
                                </> : <>
                                    <span class='ml-2'>
                                        {field.type === 'toggle' ? <>
                                            {convention[key] ? <>
                                                <i class='fa-solid fa-check text-success' />
                                            </> : <>
                                                <i class='fa-solid fa-times text-danger' />
                                            </>}
                                        </> : <>
                                            {displayValue(convention[key])}
                                        </>}
                                    </span>
                                </>}
                            </div>}
                        </>);
                    })}

                </> : <>
                    {[
                        'startDate',
                        'endDate',
                        'isCompetition',
                        'isNsfClassLeading',
                        'nsfNumber',
                        'ingress',
                        'body',
                    ].map(key => {
                        if (util.isUndefined(convention[key])) {
                            return '';
                        }
                        const field = fields.getField('convention', key);
                        if (!field) {
                            console.log('Missing field:', key);
                        }
                        const displayValue = field?.displayValue || (value => value);
                        return (<>
                            {(convention[key] || convention[key] === false) && <div class='d-flex flex-row'>
                                {!['ingress', 'body'].includes(key) && <span class='text-muted font-weight-light'>
                                    {field.title}
                                </span>}
                                {['textarea', 'textareaEditor'].includes(field.type) ? <>
                                    <div class='ml-0  mb-4 text-wrap' style='max-height: 60vh; overflow: auto;'>
                                        <Markdown markdown={displayValue(convention[key])} markedOpts={MARKDOWN_OPTIONS} />
                                    </div>
                                </> : <>
                                    <span class='ml-2'>
                                        {field.type === 'toggle' ? <>
                                            {convention[key] ? <>
                                                <i class='fa-solid fa-check text-success' />
                                            </> : <>
                                                <i class='fa-solid fa-times text-danger' />
                                            </>}
                                        </> : <>
                                            {displayValue(convention[key])}
                                        </>}
                                    </span>
                                </>}
                            </div>}
                        </>);
                    })}
                </>}
            </div>
        </>);
    }
}
export default ConventionViewInfo;
